<template>
  <el-dialog
    title="Relatórios de Clientes - Venda"
    :visible.sync="visibility"
    :before-close="fechar"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    @open="reset"
    width="35%"
  >
    <el-form
      v-model="relatorio"
      ref="form"
      size="small"
      label-position="top"
      hide-required-asterisk
      :show-message="false"
    >
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="Relatório">
            <el-select
              auto-complete="off"
              v-model="relatorio.nome"
              clearable
              placeholder
              style="width: 100%;"
            >
              <el-option
                v-for="item in tiposRelatorios"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <span v-if="exibirCamposCadastrados">Categoria do Cliente</span>
      <el-row :gutter="24" v-if="exibirCamposCadastrados">
        <el-col :span="8">
          <el-checkbox v-model="relatorio.clienteProprietario">Proprietário</el-checkbox>
        </el-col>
        <el-col :span="8">
          <el-checkbox v-model="relatorio.clienteComprador">Comprador</el-checkbox>
        </el-col>
      </el-row>

      <p/>

      <el-row v-if="exibirCampos" :gutter="24">
        <el-col :span="12">
          <el-form-item label="Data Inicial" prop="dataInicial">
            <el-date-picker
              v-model="relatorio.dataInicial"
              v-mask="'##/##/####'"
              type="date"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Data Final" prop="dataFinal">
            <el-date-picker
              v-model="relatorio.dataFinal"
              v-mask="'##/##/####'"
              type="date"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <p/>

      <span v-if="exibirCamposCadastrados">Faixa de Renda</span>
      <el-row :gutter="24" v-if="exibirCamposCadastrados">
        <el-col :span="0.01">
          <p></p>
          <span>de</span>
        </el-col>
        <el-col :span="9">
          <el-form-item label prop="rendaInicial">
            <money v-model="relatorio.rendaInicial" v-bind="money" class="el-input__inner"/>
          </el-form-item>
        </el-col>
        <el-col :span="0.01">
          <p></p>
          <span>até</span>
        </el-col>
        <el-col :span="9">
          <el-form-item label prop="rendaFinal">
            <money v-model="relatorio.rendaFinal" v-bind="money" class="el-input__inner"/>
          </el-form-item>
        </el-col>
      </el-row>

      <p/>

      <span v-if="exibirCamposCadastrados">Tipo</span>
      <el-row v-if="exibirCamposCadastrados" :gutter="24">
        <el-col :span="24">
          <el-radio-group v-model="relatorio.personalidadeJuridica" label="Tipo" style="font-size: small;">
            <el-radio label="TODOS">Todos</el-radio>
            <el-radio label="PESSOA_FISICA">Pessoa Física</el-radio>
            <el-radio label="PESSOA_JURIDICA">Pessoa Jurídica</el-radio>
          </el-radio-group>
        </el-col>
      </el-row>

      <p/>

      <span v-if="exibirCamposPessoaFisica">Sexo</span>
      <el-row v-if="exibirCamposPessoaFisica" :gutter="20">
        <el-col :span="20">
          <el-radio-group v-model="relatorio.sexo" label="Sexo">
            <el-radio label="TODOS">Todos</el-radio>
            <el-radio label="MASCULINO">Masculino</el-radio>
            <el-radio label="FEMININO">Feminino</el-radio>
          </el-radio-group>
        </el-col>
      </el-row>

      <p/>

      <el-row v-if="exibirCamposCadastrados" :gutter="24">
        <el-col :span="24">
          <el-form-item label="Bairro do Cliente">
            <el-input v-model="relatorio.bairro"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row v-if="exibirCampos" :gutter="24">
        <el-col :span="24">
          <el-form-item label="Atendente">
            <el-select
              v-model="relatorio.usuario"
              :remote-method="filtrarUsuariosSelect"
              :loading="loadingUsuarios"
              @focus="filtrarUsuariosSelect"
              value-key="id"
              placeholder
              loading-text="Carregando usuários"
              no-data-text="Nenhum usuário encontrado"
              filterable
              clearable
              @clear="relatorio.usuario = undefined"
              remote
              reserve-keyword
              style="width: 100%"
            >
              <el-option
                v-for="item in usuariosDisponiveis"
                :key="item.id"
                :label="item.nome"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button type="primary" size="small" @click="gerar()" round class="btn-box-shadow">Gerar Relatório</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { Money } from "v-money";
import funcoes from "../../../util/funcoes.js";

export default {
  props: {
    visibility: Boolean
  },
  components: {
    Money
  },
  data() {
    return {
      relatorio: {
        nome: undefined,
        personalidadeJuridica: "TODOS",
        sexo: "TODOS",
        bairro: undefined,
        usuario: undefined,
        dataInicial: funcoes.primeiroDiaMes(),
        dataFinal: funcoes.ultimoDiaMes(),
        rendaInicial: "",
        rendaFinal: "",
        categoriasClientes: [],
        clienteProprietario: true,
        clienteComprador: true
      },

      tiposRelatorios: [
          {
            value: "CLIENTES_POR_CORRETOR",
            label: "Clientes Cadastrados"
          },
          {
            value: "CONTATO_REALIZADO",
            label: "Contatos Realizados"
          }
        ],

      loadingUsuarios: false,

      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      }
    };
  },
  computed: {
    ...mapState("vendasRelatoriosStore", {
      usuariosDisponiveis(state) {
        return state.usuariosDisponiveis;
      }
    }),
    exibirCamposCadastrados() {
      return this.relatorio.nome == "CLIENTES_POR_CORRETOR";
    },
    exibirCampos() {
      return this.relatorio.nome;
    },
    exibirCamposPessoaFisica() {
      return this.relatorio.nome == "CLIENTES_POR_CORRETOR" && this.relatorio.personalidadeJuridica == "PESSOA_FISICA";
    }
  },
  methods: {
    ...mapActions(["showLoading", "hideLoading"]),
    ...mapActions("vendasRelatoriosStore", ["gerarRelatorio", "listarUsuarios"]),
    gerar() {
      if(this.relatorio.clienteProprietario) { this.relatorio.categoriasClientes.push('PROPRIETARIO'); }
      if(this.relatorio.clienteComprador) { this.relatorio.categoriasClientes.push('COMPRADOR'); }
      if(this.relatorio.personalidadeJuridica == 'TODOS') { delete this.relatorio.personalidadeJuridica; }
      if(this.relatorio.sexo == 'TODOS') { delete this.relatorio.sexo; }
      if(this.relatorio.rendaInicial == 0) { delete this.relatorio.rendaInicial; }
      if(this.relatorio.rendaFinal == 0) { delete this.relatorio.rendaFinal; }
      if(this.relatorio.nome == 'CONTATO_REALIZADO') { delete this.relatorio.categoriasClientes; }
      delete this.relatorio.clienteProprietario;
      delete this.relatorio.clienteComprador;

      this.showLoading();
      this.gerarRelatorio(this.relatorio)
        .then(resultado => {
          this.hideLoading();
          if (resultado.status == "SUCESSO") {
            window.open(resultado.mensagem, "_blank");
          }
        })
        .catch(() => {
          this.hideLoading();
          this.$message.error("Não foi possível comunicar-se com o servidor");
        });
    },
    filtrarUsuariosSelect(queryString) {
      if(queryString.type && queryString.type === 'focus') { queryString = '' }
      let payload = { nome: queryString };
      this.loadingUsuarios = true;
      this.listarUsuarios(payload).then(() => {
        this.loadingUsuarios = false;
      });
    },
    reset(){
      this.relatorio = {
        nome: undefined,
        personalidadeJuridica: "TODOS",
        sexo: "TODOS",
        bairro: undefined,
        usuario: undefined,
        dataInicial: funcoes.primeiroDiaMes(),
        dataFinal: funcoes.ultimoDiaMes(),
        rendaInicial: "",
        rendaFinal: "",
        categoriasClientes: [],
        clienteProprietario: true,
        clienteComprador: true
      }
    },
    fechar() {
      this.$emit("close");
    },
    exibirAlert(titulo, mensagem) {
      this.$alert(mensagem, titulo, { confirmButtonText: "OK" });
    }
  }
};
</script>

<style scoped>
.form-item {
  width: 100%;
}
.select {
  font-size: 50%;
}
</style>